export const setProperty = (variable: string, value: string): void => {
  document.documentElement.style.setProperty(variable, value)
}

export const getCssProperty = (variable: string): string => {
  return document.documentElement.style.getPropertyValue(variable)
}
